
import Dashboard from "./dashboard";

/**
 * HomePage - Component that renders a home page with manager data
 * @component
 */
const HomePage = () => {
    return <Dashboard />
};

export default HomePage;
